var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg16 = function Svg16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.334 4.834q.12.002.23.04.028.007.056.017.035.016.067.035a.8.8 0 0 1 .177.128.7.7 0 0 1 .127.176q.02.033.034.067.01.027.018.056c.024.073.04.15.04.231v6.667a.751.751 0 0 1-1.5 0V7.395L5.198 12.78a.75.75 0 0 1-1.06-1.06l5.386-5.387H4.667a.75.75 0 0 1 0-1.5z"
  })));
};
export default Svg16;